// Honest decision-impact formatting (pure).
//
// PRUNE #5 (VP): honor impact.basis. Show dollars_per_day ONLY for basis="dollar".
// For "severity_tier" / "flat" (predictions, approvals, health alerts with no
// spend-at-risk) show the honest non-dollar basis — NEVER a synthesized figure.
//
// Source: services/executive_ranking.py:_make_item -> item.impact = {
//   dollars_per_day, normalized_impact, basis }.

export function formatDecisionImpact(item) {
  const impact = (item && item.impact) || {};
  const basis = impact.basis || "flat";
  const dpd = impact.dollars_per_day;
  const normalized = impact.normalized_impact;

  if (basis === "dollar" && dpd != null) {
    return {
      isDollar: true,
      display: `$${Math.round(dpd).toLocaleString()}/day`,
      basisLabel: "Dollar impact/day",
      source: "impact.dollars_per_day",
    };
  }

  if (basis === "severity_tier") {
    return {
      isDollar: false,
      display: "Severity-tier priority",
      basisLabel: "No $ figure — ranked by health severity",
      normalized: normalized != null ? Number(normalized) : null,
      source: "impact.basis=severity_tier",
    };
  }

  // basis === "flat" (or anything else): explicitly no dollar basis.
  return {
    isDollar: false,
    display: "No $ basis",
    basisLabel: "Flagged — no dollar figure available",
    normalized: normalized != null ? Number(normalized) : null,
    source: "impact.basis=flat",
  };
}
